require('./setup/events');
require('./setup/prototypes');
require('./setup/initializeObservers');
require('./setup/globals');

// Инициализация TabIdManager
window.tabIdManager = new TabIdManager();